// Order-ticket formatting rules by asset class. This is DISPLAY precision only —
// callers must always store / submit the RAW entered value, never a rounded
// string. Rounding for display must never change the actual order price.

// Asset class from a Polygon-style symbol prefix: "X:" crypto, "C:" forex, else stock.
export function assetClass(symbol) {
  const s = String(symbol || "").trim();
  if (s.startsWith("X:")) return "crypto";
  if (s.startsWith("C:")) return "forex";
  return "stock";
}

// Normalize any category label ("Stocks" / "crypto" / "Forex" / "stock" …) to a
// canonical class: "crypto" | "forex" | "stock".
export function normalizeClass(cls) {
  const c = String(cls || "").toLowerCase();
  if (c.startsWith("crypto")) return "crypto";
  if (c.startsWith("forex")) return "forex";
  return "stock";
}

// Decimal places for a PRICE:
//   forex  → 4 (all pairs incl. JPY, for launch)
//   crypto → 2 when price >= $1.00, else 4
//   stock  → 2
export function priceDecimals(cls, price) {
  const c = normalizeClass(cls);
  if (c === "forex") return 4;
  if (c === "crypto") return Math.abs(Number(price)) >= 1 ? 2 : 4;
  return 2;
}

// Format a price for DISPLAY at the correct precision. Returns "" for non-numbers.
// Never feed the return value back into storage/submission — it's display-only.
export function formatOrderPrice(price, cls) {
  const n = Number(price);
  if (!Number.isFinite(n)) return "";
  return n.toFixed(priceDecimals(cls, n));
}

// Total (cost = qty × price) is a money amount: 2dp normally, 4dp for sub-$1
// totals (so a crypto cost like 0.3262 keeps its precision).
export function formatTotal(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "";
  return n.toFixed(Math.abs(n) >= 1 ? 2 : 4);
}

export function formatCash(value) {
  return `$${Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

// Quantity field label per class: stocks → Shares, crypto → Coins, forex → Units.
export function quantityLabel(cls) {
  const c = normalizeClass(cls);
  if (c === "crypto") return "Coins";
  if (c === "forex") return "Units";
  return "Shares";
}

// Forex lot sizes for the Units keypad.
export const FOREX_LOTS = [
  { key: "micro", label: "Micro lot", units: 1000 },
  { key: "mini", label: "Mini lot", units: 10000 },
  { key: "standard", label: "Standard lot", units: 100000 },
];
